import { makeStyles } from '@material-ui/core';
import { useStateRef } from '@zennya/web-component-library/src';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isAuthenticated, useUserState } from 'services/authentication.service';
import { useTrackEvent } from 'util/trackEvent';
import { STANDALONE_STEPS, START_STEP, STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION, STEP_CREATE_ACCOUNT_VERIFY_MOBILE, STEP_RECIPIENT } from './constants';
import { stepState } from './state';
import isEmpty from 'lodash.isempty';
import { useExternalLinkProcessor } from './0/Recipient/ExternalLinkProcessor';
const useStyles = makeStyles(theme => ({
}));
const Switcher = ({ }) => {
  const [step, setStep] = useRecoilState(stepState);

  const [stepExternal, setStepExternal, stepExternalRef] = useStateRef(null);

  const location = useLocation();
  const [loaded, setLoaded] = useState(false);
  const isUserAuthenticated = isAuthenticated()
  const { getUser } = useUserState()
  const processLink = useExternalLinkProcessor()

  const history = useHistory();
  // if (!isUserAuthenticated) {
  //   return <Redirect to={'/createbooking/account/signin'} />
  // }
  const trackEvent = useTrackEvent()

  const checkHasMobile = useCallback(
    async () => {
      const user = await getUser(null, true)
      const hasMobile = user?.client?.mobile_number || user?.user?.mobile_number
      const stp = location?.pathname
      if (
        [STEP_CREATE_ACCOUNT_VERIFY_MOBILE, STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION].includes(step)
        ||
        [STEP_CREATE_ACCOUNT_VERIFY_MOBILE, STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION].includes(stp)
      ) {
        return
      }
      if (process.env.REACT_APP_ENABLE_MOBILE_VERIFICATION === 'true' && !hasMobile) {
        trackEvent('AUTO - Redirect to verify mobile (user has no mobile number)')
        setStep(STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION)
        history.replace(STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION, { internal: true })
      }
    },
    [step, location?.pathname],
  );

  useEffect(
    () => {
      if (isUserAuthenticated) {
        checkHasMobile()
      }
    }, [step, location?.pathname]
  );

  useEffect(
    () => {
      if (STANDALONE_STEPS.includes(location?.pathname)) {
        history.replace(`${location?.pathname}${location?.search}`)
        setStepExternal(true)
        return
      }
      if (!isEmpty(location.search)) {
        setStep(START_STEP)
        history.replace(`${START_STEP}${location?.search}`)
        setStepExternal(true)
        return
      }
      if (location?.state?.defer) {
        history.replace(`${location?.pathname}${location?.search}`)
        return
      }
      if (!location?.state?.internal) {
        if (step) {
          setStep(step)
          history.replace(`${step}${location?.search}`)
        } else {
          setStep(START_STEP)
          history.replace(`${location?.pathname}${location?.search}`)
        }
        setStepExternal(true)
      } else {
        setStepExternal(false)
      }
    }, [location?.pathname]
  );

  useEffect(
    () => {
      if (location?.state?.defer) {
        history.replace(`${location?.pathname}${location?.search}`)
        return
      } else {
        history.replace(step, { internal: true })
      }
      if (stepExternalRef.current) {
        setStepExternal(false)
        return
      }

    }, [step, stepExternalRef]
  );

  return null
}

export { Switcher };
